import { createApp } from "vue";
import ClickOutside from "click-outside-vue3";
import { vMaska } from "maska";
import VueDatePicker from "@vuepic/vue-datepicker";
import FloatingVue from "floating-vue";

import App from "@/App.vue";
import router from "@/router";
import store from "@/store";

import "@/assets/styles/main.scss";
import "@/brand/aex.scss";
import { isAex } from "@/brand";
import "@vuepic/vue-datepicker/dist/main.css";
import "/node_modules/flag-icons/css/flag-icons.min.css";
import "floating-vue/dist/style.css";

import AxiosPlugin from "@/plugins/axios";
import i18n from "@/plugins/i18n";

import ProjectServicesPlugin from "@/plugins/project-services";
import { BemPlugin } from "@/plugins/bem";

const app = createApp(App);
if (isAex) document.documentElement.dataset.brand = "aex";

app
  .use(store)
  .use(BemPlugin)
  .use(FloatingVue)
  .use(ClickOutside)
  .use(router)
  .use(AxiosPlugin)
  .use(ProjectServicesPlugin)
  .use(i18n)
  .directive("maska", vMaska)
  .component("VueDatePicker", VueDatePicker)
  .mount("#app");
